import { useApiPrivateRequest } from "@/shared/hooks/useApi";
import { GeneratedPlaybook } from "../models/GeneratedPlaybook";
import { PlaybookDetailLevel } from "../models/PlaybookDetailLevel";

export const useGeneratePlaybook = () => {
  const {
    data: generatedPlaybook,
    call,
    isLoading: isGenerating,
    isFailed: isGenerateFailed,
  } = useApiPrivateRequest<GeneratedPlaybook>(
    (response) => new GeneratedPlaybook(response),
  );

  const generatePlaybook = async (
    title: string,
    description: string,
    detailLevel: PlaybookDetailLevel,
  ) => {
    await call(`/playbooks/generate`, "POST", undefined, {
      title,
      description,
      detailLevel,
    });
  };

  return {
    generatedPlaybook,
    generatePlaybook,
    isGenerating,
    isGenerateFailed,
  };
};
